import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

const VideoProgress = () => {
  const steps = [
    { heading: "PROCESSING", subheading: "Approx. 5 days" },
    { heading: "APPROVED", subheading: "Approx. 10 days" },
    { heading: "SENT TO STORES", subheading: "Approx. 30 days" }
  ];

  const check = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.0362 4.76351C15.2049 4.93228 15.2997 5.16116 15.2997 5.39981C15.2997 5.63846 15.2049 5.86733 15.0362 6.03611L7.83618 13.2361C7.6674 13.4048 7.43853 13.4996 7.19988 13.4996C6.96123 13.4996 6.73235 13.4048 6.56358 13.2361L2.96358 9.63611C2.79964 9.46637 2.70892 9.23902 2.71097 9.00305C2.71302 8.76707 2.80767 8.54134 2.97454 8.37447C3.14141 8.2076 3.36714 8.11295 3.60312 8.1109C3.83909 8.10885 4.06644 8.19957 4.23618 8.36351L7.19988 11.3272L13.7636 4.76351C13.9324 4.59478 14.1612 4.5 14.3999 4.5C14.6385 4.5 14.8674 4.59478 15.0362 4.76351Z"
        fill="white"
      />
    </svg>
  );

  const Cancel = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.86312 3.86363C4.03189 3.6949 4.26077 3.60012 4.49942 3.60012C4.73806 3.60012 4.96694 3.6949 5.13572 3.86363L8.99942 7.72733L12.8631 3.86363C12.9461 3.77767 13.0455 3.7091 13.1553 3.66194C13.2651 3.61477 13.3832 3.58994 13.5027 3.5889C13.6222 3.58786 13.7407 3.61063 13.8513 3.65589C13.9619 3.70114 14.0624 3.76797 14.1469 3.85247C14.2314 3.93697 14.2982 4.03746 14.3435 4.14807C14.3887 4.25867 14.4115 4.37719 14.4104 4.49669C14.4094 4.61619 14.3846 4.73429 14.3374 4.84409C14.2902 4.95389 14.2217 5.0532 14.1357 5.13623L10.272 8.99993L14.1357 12.8636C14.2997 13.0334 14.3904 13.2607 14.3883 13.4967C14.3863 13.7327 14.2916 13.9584 14.1248 14.1253C13.9579 14.2921 13.7322 14.3868 13.4962 14.3888C13.2602 14.3909 13.0329 14.3002 12.8631 14.1362L8.99942 10.2725L5.13572 14.1362C4.96598 14.3002 4.73863 14.3909 4.50266 14.3888C4.26668 14.3868 4.04095 14.2921 3.87408 14.1253C3.70721 13.9584 3.61256 13.7327 3.61051 13.4967C3.60846 13.2607 3.69918 13.0334 3.86312 12.8636L7.72682 8.99993L3.86312 5.13623C3.69439 4.96745 3.59961 4.73857 3.59961 4.49993C3.59961 4.26128 3.69439 4.0324 3.86312 3.86363Z"
        fill="white"
      />
    </svg>
  );
  return (
    <Container>
      {steps.map((step, i) => {
        return (
          <StepContainer key={i}>
            <StepContainer>
              <StepNumber
                bgcolor={i === 0 ? Colors.yellow400 : Colors.grey600}
                color={i === 0 ? Colors.white100 : Colors.grey500}
              >
                {i + 1}
              </StepNumber>
              <StepText>
                <Typography size="s" weight="semibold" mb="0.1" m_size="xs">
                  {step.heading}
                </Typography>
                <Typography size="xs">{step.subheading}</Typography>
              </StepText>
            </StepContainer>
            {i !== steps.length - 1 && <Line />}
          </StepContainer>
        );
      })}
    </Container>
  );
};

export default VideoProgress;

const Container = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 769px) {
    justify-content: space-between;
  }
`;
const StepContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StepNumber = styled.div<{ bgcolor: string; color: string }>`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.bgcolor};
  color: ${(props) => props.color};
  @media only screen and (max-width: 769px) {
    width: 2rem;
    height: 2rem;
  }
`;

const StepText = styled.div``;

const Line = styled.div`
  width: 3.2rem;
  height: 1px;
  border-top: 1px solid ${Colors.grey400};
  margin: 0 0.8rem;
`;
